import { render, staticRenderFns } from "./UserGrid.vue?vue&type=template&id=f863cfd0&"
import script from "./UserGrid.vue?vue&type=script&lang=js&"
export * from "./UserGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports